let ImagesLazy = {
    observer: null,
    imageCount: 0,

    /**
     * Fetchs the image for the given URL
     * @param {string} url
     */
    fetchImage: function(url) {
        return new Promise(function(resolve, reject){
            const image = new Image();
            image.src = url;
            image.onload = resolve;
            image.onerror = reject;
        });
    },

    /**
     * Preloads the image
     * @param image
     */
    preloadImage: function(image, srcIndex) {
        let source;
        let sourceSet = image.dataset.srcset ? image.dataset.srcset.split(',') : [];
        if (image.dataset.src) {
            sourceSet.unshift(image.dataset.src);
        }

        if (typeof srcIndex != 'number') {
            srcIndex = 0;
        }

        if (srcIndex < sourceSet.length) {
            source = sourceSet[srcIndex];
            return ImagesLazy.fetchImage(source).then(function(){
                ImagesLazy.applyImage(image, source);
            }, function(){
                if (++srcIndex < sourceSet.length) {
                    ImagesLazy.preloadImage(image, srcIndex);
                }
            });
        }
    },

    /**
     * Load all of the images immediately
     * @param {NodeListOf<Element>} images
     */
    loadImagesImmediately: function(images) {
        // foreach() is not supported in IE
        for (i = 0; i < images.length; i++) {
            ImagesLazy.preloadImage(images[i]);
        }
    },

    /**
     * Disconnect the observer
     */
    disconnect: function() {
        if (!ImagesLazy.observer) {
            return;
        }

        ImagesLazy.observer.disconnect();
    },

    /**
     * On intersection
     * @param {array} entries
     */
    onIntersection: function(entries) {
        // Disconnect if we've already loaded all of the images
        if (ImagesLazy.imageCount === 0) {
            ImagesLazy.observer.disconnect();
        }

        // Loop through the entries
        for (i = 0; i < entries.length; i++) {
            // Are we in viewport?
            if (entries[i].intersectionRatio > 0) {
                ImagesLazy.imageCount--;

                // Stop watching and load the image
                ImagesLazy.observer.unobserve(entries[i].target);
                ImagesLazy.preloadImage(entries[i].target);
            }
        }
    },

    /**
     * Apply the image
     * @param {object} img
     * @param {string} src
     */
    applyImage: function(img, src) {
        // Prevent this from being lazy loaded a second time.
        img.classList.add('js-lazy-image-handled');
        img.src = src;
        img.classList.add('fade-in');
    },

    addImages: function(images){
        // If we don't have support for intersection observer, loads the images immediately
        if (!('IntersectionObserver' in window)) {
            ImagesLazy.loadImagesImmediately(images);
        } else {
            // It is supported, load the images
            ImagesLazy.observer = new IntersectionObserver(ImagesLazy.onIntersection, ImagesLazy.config);

            // foreach() is not supported in IE
            let i;
            for (i = 0; i < images.length; i++) {
                let image = images[i];
                if (image.classList.contains('js-lazy-image-handled')) {
                    continue;
                }
                ImagesLazy.imageCount++;
                ImagesLazy.observer.observe(image);
            }
        }
    },

    config:{
        // If the image gets within 50px in the Y axis, start the download.
        // root: document.querySelector('#scrollArea'),
        rootMargin: '50px 0px',
        threshold: 0.01
    }
};

(function ($) {

    $(document).ready(function ($) {
        // Get all of the images² that are marked up to lazy load
        const images = document.querySelectorAll('img.lazy');
        ImagesLazy.addImages(images);

    });

}(jQuery));
